function isJSONString(value: any) {
  if (typeof value === "string") {
    try {
      JSON.parse(value);
      return true;
    } catch (error) {
      return false;
    }
  }
  return false;
}

export { isJSONString };
